// fetch /careers/roles.json

const fetchRoles = async () => {
    const response = await fetch("/roles.json");
    const roles = await response.json();
    return roles.map(role => {
        return Object.assign({}, role, {
            location: role.displayedLocation,
            type: role.title,
            url: "/careers/" + role.slug,
            salary: {
                from: `${role.salaryMinimum}`,
                to: `${role.salaryMaximum}`
            }
        })
    });
};
fetchRoles().then(result => {
    window.roles = result;

    roles.forEach(role => {
        if (!roleTypes.includes(role.type)) {
            roleTypes.push(role.type);
            roleTypesSelect.innerHTML += `<option value="${role.type}">${role.type}</option>`;
        }
    });

    //hide .careers-loading
    document.querySelector(".careers-loading").style.display = "none";
    //show .careers-landing
    document.querySelector(".careers-landing").style.display = "block";
});

var roleTypes = [];
var roleLocations = [];

const roleTypesSelect = document.getElementById("roleTypes");
const roleLocationsSelect = document.getElementById("roleLocations");
const roleSearchButton = document.getElementById("roleSearch");
const filterResults = document.getElementById("filter-results").querySelector(".row");
const widerResults = document.getElementById("wider-results").querySelector(".row");
const resultCount = document.getElementById("result-count");
const roleTypeDisplay = document.getElementById("role-type");
const locationDisplay = document.getElementById("location");
const pluralDisplay = document.getElementById("plural");

const displayRoles = (roleLocation, roleType) => {
    let filteredRoles = roles.filter(role => role.location === roleLocation && role.type === roleType);
    let widerRoles = roles.filter(role => role.location !== roleLocation && role.type === roleType);

    filterResults.innerHTML = "";
    filteredRoles.forEach(role => {
        filterResults.innerHTML += ` 

      <div class="col-12 col-md-6">
        <div class="role-result">
          <div class="location">${role.location}</div>
          <h3>${role.type}</h3>
          <div class="salary">
            Salary - ${role.displayedSalary}
          </div>
          <a href="${role.url}" class="cta-btn">FIND OUT MORE</a> 
          <a href="${role.links.apply}" class="apply">APPLY NOW</a>
        </div>
      </div>
    `;
    });

    if (filteredRoles.length === 1) {
        pluralDisplay.innerHTML = "";
    } else {
        pluralDisplay.innerHTML = "s";
    }

    widerResults.innerHTML = "";
    widerRoles.forEach(role => {
        widerResults.innerHTML += ` 

      <div class="col-12 col-md-4">
        <div class="role-result">
          <div class="location">${role.location}</div>
          <h3>${role.type}</h3>
          <div class="salary">
            Salary - ${role.displayedSalary}
          </div>
          <a href="${role.url}" class="cta-btn">FIND OUT MORE</a> 
          <a href="${role.links.apply}" class="apply">APPLY NOW</a>
        </div>
      </div>

    `;
    });

    resultCount.innerHTML = filteredRoles.length;
    roleTypeDisplay.innerHTML = roleTypesSelect.value;
    locationDisplay.innerHTML = roleLocationsSelect.value;

    document.querySelectorAll(".showWithResults").forEach(el => {
        el.classList.add("show");
    });
    console.log(widerRoles.length);
    if (widerRoles.length > 0) {
        console.log("show");
        document.querySelectorAll(".showWithWiderResults").forEach(el => {
            el.classList.add("show");
        });
    } else {
        console.log("hide");
        document.querySelectorAll(".showWithWiderResults").forEach(el => {
            el.classList.remove("show");
        });
    }
};

roleTypesSelect.addEventListener("change", e => {
    filterResults.innerHTML = "";
    widerResults.innerHTML = "";
    document.querySelectorAll(".showWithResults").forEach(el => {
        el.classList.remove("show");
    });
    document.querySelectorAll(".showWithWiderResults").forEach(el => {
        el.classList.remove("show");
    });

    let filteredRoles = roles.filter(role => role.type === e.target.value);
    let locationsWithRoles = [];
    filteredRoles.forEach(role => {
        if (!locationsWithRoles.includes(role.location)) {
            locationsWithRoles.push(role.location);
        }
    });
    roleLocationsSelect.innerHTML = `<option value="">Select Location</option>`;
    let roleLocations = [];
    filteredRoles.forEach(role => {
        if (!roleLocations.includes(role.location)) {
            roleLocations.push(role.location);
            roleLocationsSelect.innerHTML += `<option value="${role.location}">${role.location}</option>`;
        }
    });
});

roleSearchButton.addEventListener("click", e => {
    displayRoles(roleLocationsSelect.value, roleTypesSelect.value);
});
